import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import Controls from "../../../atoms/Controls";
import { useLocationId } from "../../../stores/User/User.hooks";
import { useUpdateCancelledAppointment } from "../../../stores/Appointment/appointment.mutation";
import notificationStore from "../../../stores/Notification/notificationStore";
import { AppointmentDto } from "../../../api-client";
import { observer } from "mobx-react";
import { useCancelledAppointmentForAppointmentId } from "../../../stores/Appointment/appointment.queries";
import { formatDateUI } from "../../../helpers/dateFormat";

interface EditCancellationDialogProps {
  open: boolean;
  appointment: AppointmentDto;
  patientId: number;
  onClose: (actionPerformed: boolean) => void;
}

const EditCancellationDialog: React.FC<EditCancellationDialogProps> = observer(
  ({ open, appointment, patientId, onClose }) => {
    const locationId = useLocationId();
    const updateCancelledAppointment = useUpdateCancelledAppointment({ locationId, patientId });
    const { data: cancelledAppointmentData } = useCancelledAppointmentForAppointmentId(
      appointment.id!
    );
    const [cancelReason, setCancelReason] = useState(appointment.reason || "");
    const handleSaveCancelReason = async () => {
      try {
        updateCancelledAppointment.mutate({
          id: cancelledAppointmentData?.id!,
          dto: {
            reason: cancelReason,
          },
        });

        notificationStore.showMessage("Stornierungsgrund gespeichert", "success");
        onClose(true);
      } catch (error) {
        notificationStore.showMessage("Fehler beim Speichern des Stornierungsgrunds", "error");
      }
    };
    const handleCancel = () => {
      onClose(!open);
    };

    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Stornierungsgrund bearbeiten- {formatDateUI(cancelledAppointmentData?.originalDate)} </DialogTitle>
        <DialogContent>
          <Controls.TextArea
            label="Stornierungsgrund"
            value={cancelReason}
            onChange={(e: any) => setCancelReason(e.target.value)}
            fullWidth
            multiline
            minRows={7}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Abbrechen</Button>
          <Button onClick={handleSaveCancelReason} color="primary" variant="contained">
            Speichern
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

export default EditCancellationDialog;
